export default __webpack_public_path__ + "static/media/instagramDefault.5d8eb62b.svg";